import React from "react";
import './DigitalFootprint.css'
import '../components/ProductsHeroBanner';
import ProductHeroBanner from "../components/ProductsHeroBanner";
import Navbar from '../components/Navbar'
//import Solutions from "../components/Solutions";
//import digitalFootprintSolutionsData from "../components/digitalFootprintSolutionsData";
import Footer from "../components/Footer";
import ContentBlocks from "../components/ContentBlocks";
import CallToAction from "../components/CallToAction";
import { Helmet } from "react-helmet";

const DigitalFootprint = () => {

    const pageData = {
        heading: "Digital Footprint Features",
        blocks: [
            {
                blockHeading: "Practice Websites",
                text: "Convert page views into patients with a responsive website tailored to your specialty. Secure it with HTTPS, create dedicated service pages, and attract prospects with SEO."
            },
            {
                blockHeading: "Attract more patients (SEO)",
                text: "By using Doclivo’s SEO services, you can boost your practice's visibility on major search platforms, ensuring that more patients can find you when searching for healthcare services online."
            },
            {
                blockHeading: "Own Your Profiles",
                text: "Optimize your online profiles across search engines, maps, and prominent healthcare and local directories, making it simple for patients to locate you."
            },
           
        ]
    };

    return (
        <>
            <Helmet>
                <title> DigitalFootprint - Doclivo</title>
                <meta name="description" content="Learn more about Your Company Name, the leading provider of automation and optimization solutions." />
                <meta name="keywords" content="about us, company, automation" />
            </Helmet>
            <Navbar></Navbar>
            <section className="Digital-Footprint-section">
                <div className="Digital-Footprint-container">
                    <h5 className="Digital-Footprint-subheading">Expand your practice without increasing your workload. </h5>
                    <h1 className="Digital-Footprint-main-heading">Establish your online presence, gain more exposure, and create connections with the right patients. You don’t need a marketing degree, you just need Doclivo</h1>
                </div>

                <ProductHeroBanner></ProductHeroBanner>

                <ContentBlocks
                    heading={pageData.heading}
                    subheading={pageData.subheading}
                    blocks={pageData.blocks}
                />
                <CallToAction></CallToAction>
            </section>
            <Footer></Footer>
        </>
    );
};

export default DigitalFootprint;